import React from "react";

export default function DisplayCupsArray(props) {

    return <div id="select-cups">
        <h3>Select a cup</h3>
        {
            props.width >= 800 ?
                <ul id="cup-table">
                    {
                        defaultRows.map(element => {
                            return element.map((element, key) => {
                                return <img
                                    role="button"
                                    key={key}
                                    className="cup-icon"
                                    id={element}
                                    src={props.cups.get(element).emblem}
                                    alt={`${props.cups.get(element).display} Cup Emblem`}
                                    title={`${props.cups.get(element).display} Cup`}
                                    tabIndex="0"
                                    draggable={false}
                                    onClick={() => props.setShownCup(element)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            props.setShownCup(element)
                                        }
                                    }}
                                />
                            })
                        })
                    }
                </ul>
                : <div className="cup-dropdown"
                    style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: 10 }}>
                    <img
                        className="cup-emblem"
                        src={props.cups.get(props.shownCup).emblem}
                        alt={`${props.cups.get(props.shownCup).display} Cup Emblem`}
                        title={`${props.cups.get(props.shownCup).display} Cup`}
                        draggable={false}
                    />
                    <select id="cup-select" value={props.shownCup} onChange={(e) => props.setShownCup(e.target.value)} tabIndex={0}>
                        {
                            allCupsArray.map((element, index) => <option value={element} key={index}>
                                {props.cups.get(element).display + " Cup"}
                            </option>
                            )
                        }
                    </select>
                </div>
        }
    </div>
}

// holds the different versions of how tracks can be displayed:
// either as a table (in game), or as a drop down when the screen width is too narrow.
const defaultRows = [
    ["mushroom", "flower", "star", "special", "egg", "crossing"],
    ["shell", "banana", "leaf", "lightning", "triforce", "bell"],
    ["golden-dash", "lucky-cat", "turnip", "propeller", "rock", "moon"],
    ["fruit", "boomerang", "feather", "cherry", "acorn", "spiny"]
];

const allCupsArray = ["mushroom", "flower", "star", "special",
    "shell", "banana", "leaf", "lightning",
    "egg", "triforce", "crossing", "bell",
    "golden-dash", "lucky-cat", "turnip", "propeller",
    "rock", "moon", "fruit", "boomerang",
    "feather", "cherry", "acorn", "spiny"
];